import { completeName, dateDiffWithTodayDetail, i18n } from '../../utils';

export const normalizeDataTableAgendas = (payload: any) => {
  const data = payload?.data?.items;
  return data ? data.map((item: any) => ({
    eventId: item.eventId,
    userId: item.userId,
    userName: completeName(item.firstName, item.middleName, item.lastName),
    referenceId: item.referenceId,
    referenceName: completeName(item.referenceFirstName, item.referenceMiddleName, item.referenceLastName),
    group: item.groupName,
    agendaName: i18n(item.name),
    agendaObservation: item.observation,
    agendaNotificationTimestamp: item.notificationTimestamp,
    timeToNotification: dateDiffWithTodayDetail(item.notificationTimestamp),
  })) : [];
}
